// Import the functions you need from the SDKs you need
import { getApp, getApps, initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import {
  getDatabase,
  ref,
  onChildAdded,
  limitToLast,
  query,
  get,
} from "firebase/database";
const firebaseConfig = {
  apiKey: "AIzaSyAPLv2wYQnu-JQnygQ2Ry8axoWDvOqb_cA",
  authDomain: "simplici-authentication.firebaseapp.com",
  projectId: "simplici-authentication",
  databaseURL:
    "https://simplici-authentication-default-rtdb.asia-southeast1.firebasedatabase.app",
  storageBucket: "simplici-authentication.firebasestorage.app",
  messagingSenderId: "949864864958",
  appId: "1:949864864958:web:4cf006ac4b24732dd4d2ef",
  measurementId: "G-0G19VQZE9H",
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

const db = getDatabase(app);
const messaging = getMessaging(app);

export {
  messaging,
  db,
  limitToLast,
  query,
  ref,
  getToken,
  onMessage,
  onChildAdded,
  get,
};
